import Vue from 'vue'
import Router from 'vue-router'

import Index from './sub-route/index'                          // 首页路由
import TaskList from './sub-route/task-list'                   // 任务列表路由
import BloomTest from './sub-route/bloom-test'                   // 考试练习路由
import AdmissionTicket from './sub-route/admission-ticket'     // 准考证路由
import VolunteerAudition from './sub-route/volunteer-audition' // 选择志愿和面试方式路由
import MPayment from './sub-route/Mpayment'                    // 商品支付相关
import InvoiceAbout from './sub-route/invoice-about'           // 发票相关
import ApplyAbout from './sub-route/apply-about'               // 报名相关
import GameData from './sub-route/game-data'                   // 比赛详情内容介绍路由
import SicTask from './sub-route/sic-task'                     // SIC的专属任务路由
import LandingPage from './sub-route/landing-page'             // SIC的专属任务路由
import ImgPage from './sub-route/img-page'                     // 图片页面路由
import BloomPact from './sub-route/bloom-pact'                 // 项目协议路由
import Team from './sub-route/team'                            // 组队
import PersonalCenter from './sub-route/personal-center'       // 个人中心
import WonderfulMoment from './sub-route/wonderful-moment'     // 精彩图集
import BloomLive from './sub-route/bloom-live'                 // 直播
import EventPlaza from './sub-route/event-plaza'               // 活动广场
import SubTask from './sub-route/sub-task'                     // 二级子任务
import Advertisement from './sub-route/advertisement'          // 广告相关
import Conversation from './sub-route/conversation'            // 会话
import life from './sub-route/life'                            // bloom项目的人生
import Discover from './sub-route/discover'                    // 发现
import Proctor from './sub-route/proctor'                      // 手机监考

// 示例dome
const DomeVue = r => require.ensure(
  [],
  () => r(require('@/components/dome/dome-vue')),
  'dome'
)

// 示例dome
const wxTest = r => require.ensure(
  [],
  () => r(require('@/components/dome/wxtest')),
  'wxTest'
)

// 示例dome
const processManage = r => require.ensure(
  [],
  () => r(require('@/components/process-manage/')),
  'processManage'
)

// 示例dome
const wechatPublicBind = r => require.ensure(
  [],
  () => r(require('@/components/wechat/')),
  'wechatPublicBind'
)
Vue.use(Router)
// const router = new Router({
//
//   routes
//
// })

const VueRouterPush = Router.prototype.push

Router.prototype.push = function push (to) {
  // return VueRouterPush.call(this, to).catch(err => err)
  return VueRouterPush.call(this, to)
}
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location)
}
export default new Router({
  routes: [
    ...Index,
    ...TaskList,            // 学生的任务列表
    ...BloomTest,           // 练习考试
    ...AdmissionTicket,     // 准考证
    ...VolunteerAudition,   // 选择志愿和面试方式
    ...MPayment,            // 商品支付相关
    ...InvoiceAbout,        // 发票相关
    ...ApplyAbout,          // 报名相关
    ...GameData,            // 比赛详情内容介绍
    ...SicTask,             // SIC的专属任务
    ...LandingPage,         // 落地页
    ...ImgPage,             // 图片页面
    ...BloomPact,           // 项目协议
    ...Team,                // 组队
    ...PersonalCenter,      // 个人中心
    ...WonderfulMoment,     // 精彩图集
    ...BloomLive,           // 直播
    ...EventPlaza,          // 活动广场
    ...SubTask,             // 二级子任务
    ...Advertisement,       // 广告相关
    ...Conversation,        // 会话
    ...life,                // bloom项目的人生
    ...Discover,            // 发现
    ...Proctor,
    // 示例dome
    {
      path: '/DomeVue',
      name: 'DomeVue',
      component: DomeVue
    },
    {
      path: '/wxTest',
      name: 'wxTest',
      component: wxTest
    },
    {
      path: '/processManage',
      name: 'processManage',
      component: processManage
    },
    {
      path: '/wechatPublicBind',
      name: 'wechatPublicBind',
      component: wechatPublicBind
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js